/** @format */

import {Table} from '@sttark/design-system';
import React from 'react';

export const CompanyUsersList = props => {
    const {users} = props;

    if (!users.length) {
        return (
            <aside className="alert alert-info mt-4" role="alert">
                No users found.
            </aside>
        );
    }

    return (
        <Table
            columns={[
                {key: 'user_name', title: 'User Name', index: 'user_name'},
                {key: 'email', title: 'Email', index: 'email'},
                // holding off on these for now
                // {key: 'role', title: 'Role', index: 'role'},
                // {key: 'permissions', title: 'Permissions', index: 'permissions'},
                // {key: 'last_seen', title: 'Last Seen', index: 'last_seen'},
                {key: 'id', title: 'ID', index: 'id'}
            ]}
            rows={users.map(user => ({
                user_name: user.name,
                email: user.email,
                key: user.id,
                id: user.id
            }))}
        />
    );
};
